// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1509642786368
      const cssReload = require("../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/app.css
// module id = 228
// module chunks = 0